// RequireNoneAuth.js
'use client';
'use strict';
import { connect } from 'react-redux';

import getMeData from '../selector/getMeData.js';
import handleLoginToken from '../action/handleLoginToken.js';
import RequireNoneAuth from '../component/RequireNoneAuth.jsx';

const mapStateToProps = state => {
  return {
    isAuthed: !!getMeData(state, 'id'),
    token: getMeData(state, 'token'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleLoginToken: ({ token }) => dispatch(handleLoginToken({ token })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequireNoneAuth);
